import React from 'react'
import classNames from 'classnames'
import { IntegrationServiceId } from '../../common/integrations'
import { IntegrationIcon } from '../../components/IntegrationIcon'
import { ReactComponent as BankIcon } from '../../assets/images/bank-icon.svg'

interface CrossClientIntegrationIconProps {
  serviceId: IntegrationServiceId
  className?: string
  width?: string | number
  height?: string | number
}

export const CrossClientIntegrationIcon: React.FC<CrossClientIntegrationIconProps> = ({ serviceId, className, width, height }) => {
  if (serviceId === IntegrationServiceId.E_MONEY) {
    return <BankIcon className={classNames('zocks-text-gray-600', className)} width={width} height={height} />
  }

  return <IntegrationIcon serviceId={serviceId} className={className} width={width} height={height} />
}
